var CheckoutStorage = {
    nameStorage: nameStorageString,

    setCookie: function (name, value, days = 365) {
        let date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        document.cookie = `${name}=${encodeURIComponent(value)}; expires=${date.toUTCString()}; path=/`;
    },

    getCookie: function (name) {
        let cookies = document.cookie.split('; ');
        let cookieObj = {};
        cookies.forEach(cookie => {
            let [key, value] = cookie.split('=');
            cookieObj[key] = decodeURIComponent(value);
        });
        return cookieObj[name] ? JSON.parse(cookieObj[name]) : {};
    },

    updateStorage: function (input = '') {
        var name = input.attr('name');
        var type = input.attr('type');
        var value;

        switch (type) {
            case 'radio':
                value = input.val();
                break;
            case 'checkbox':
                value = input.is(':checked') ? 1 : 0;
                break;
            default:
                value = input.val();
        }

        var storedData = this.getCookie(this.nameStorage);
        storedData[name] = value;
        this.setCookie(this.nameStorage, JSON.stringify(storedData));
    },

    updateStorageSelect: function (name, data) {
        var storedData = this.getCookie(this.nameStorage);
        storedData[name] = data;
        this.setCookie(this.nameStorage, JSON.stringify(storedData));
    },

    getStorage: function () {
        let storedValues = this.getCookie(this.nameStorage);

        if (user_id === 'de2805f849e23a72e1f342975df9172a' && storedValues['city_params'] && !Array.isArray(storedValues['city_params'])) {
            $('[name=city_id]').val(storedValues['city_params']['city_id']);
            $('[name=city_guid]').val(storedValues['city_params']['city_guid']);
            $('.js__select_search_checkout[data-select=city]').val(storedValues['city_params']['name']);

            $('.js__delivery_block').removeClass('d_none_bootstrap');
        }

        for (let key in storedValues) {
            const input = $(`.input_input_checkout[name=${key}], .input_radio_checkout[name=${key}]`);
            const type = input.attr('type');

            switch (type) {
                case 'text':
                    input.val(storedValues[key]).blur();
                    break;
                case 'radio':
                    $(`#${key}_${storedValues[key]}`).trigger('click');
                    break;
            }
        }
    },
}

window.CheckoutStorage = CheckoutStorage